import Vue from 'vue';
import App from './App.vue';

// SCSS
import '../scss/app.scss';

// Store & Router
import router from './models/router.js';
import store from './models/stores.js';

import Meta from 'vue-meta';
Vue.use(Meta);

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

import anime from 'animejs/lib/anime.es';

//With router
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');